import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { IconPlus } from "@/components/Icons";
import { Button, Field, FieldRow, Input, Popover } from "@/components/kit";
import { createEventAction } from "@/lib/actions/events";
import { toCode } from "@/lib/builder";

/** Starting a Games: a name, a code, and when it runs. Everything else about it
 * lives in the sports that go inside, so there is nothing else to ask. */
export function NewEvent() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [code, setCode] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function create() {
    setBusy(true);
    setError(null);
    try {
      const result = await createEventAction({
        code: code || toCode(name),
        name,
        startDate: from || undefined,
        endDate: to || undefined,
      });
      if (result.ok) {
        setOpen(false);
        navigate(`/events/${result.code}`);
      } else {
        setError(result.error);
      }
    } finally {
      // Release the button even if the action rejects at the transport layer.
      setBusy(false);
    }
  }

  return (
    <Popover
      open={open}
      onClose={() => setOpen(false)}
      align="right"
      wide
      trigger={
        <Button tone="primary" onClick={() => setOpen(!open)}>
          <IconPlus size={15} />
          Add an event
        </Button>
      }
    >
      <div style={{ display: "grid", gap: "var(--s3)", minWidth: 320 }}>
        <Field label="Name" required htmlFor="e-name">
          <Input
            id="e-name"
            value={name}
            placeholder="Paris 2028"
            onChange={(e) => {
              setName(e.target.value);
              if (code === toCode(name)) setCode(toCode(e.target.value));
            }}
          />
        </Field>
        <Field label="Code" hint="What everything else points at" htmlFor="e-code">
          <Input
            id="e-code"
            value={code || toCode(name)}
            onChange={(e) => setCode(toCode(e.target.value))}
          />
        </Field>
        <FieldRow>
          <Field label="From" htmlFor="e-from">
            <Input id="e-from" type="date" value={from} onChange={(e) => setFrom(e.target.value)} />
          </Field>
          <Field label="To" htmlFor="e-to">
            <Input id="e-to" type="date" value={to} onChange={(e) => setTo(e.target.value)} />
          </Field>
        </FieldRow>
        {error && (
          <p style={{ margin: 0, fontSize: "var(--t-sm)", color: "var(--bad)" }}>{error}</p>
        )}
        <Button tone="primary" disabled={!name.trim() || busy} onClick={create}>
          {busy ? "Creating…" : "Create"}
        </Button>
      </div>
    </Popover>
  );
}
